import { createLucideIcon } from "lucide-react";

export const CancelCircle = createLucideIcon(
    "CancelCircle",
    [
        [
            "path",
            {
                d: "M14.9994 15L9 9",
                key: "3qyz7d",
            },
        ],
        [
            "path",
            {
                d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
                key: "170qnq",
            },
        ],
        [
            "path",
            {
                d: "M9.0006 15L15 9",
                key: "1oag4k",
            },
        ],
    ],
);
